import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbsDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconThumbsDown"><Path d="M17.5485 13.5H21.5485V3.5H17.5485M17.5485 13.5L13.0002 21.5H12.388C11.1594 21.5 10.2213 20.4026 10.4123 19.189L11.0324 15.25H5.60233C3.74432 15.25 2.3331 13.5783 2.64487 11.7466L3.62359 5.9966C3.86902 4.55473 5.11845 3.5 6.58106 3.5H17.5485M17.5485 13.5V3.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconThumbsDown;
